import { CrudFilter, LogicalFilter } from '@refinedev/core';

/**
 * Convert filters to a record of field-value pairs.
 *
 * Only simple equality filters are supported.
 *  ex : `{ field: 'email', operator: 'contains', value: 'test' }` => `{ email: 'test' }`
 * @param filters - The filters to adapt.
 * @returns The adapted filters.
 */
export const adaptFilters = (
  filters: CrudFilter[] | undefined,
): Record<string, LogicalFilter['value']> => {
  if (!filters) {
    return {};
  }

  return Object.fromEntries(
    filters
      .filter((filter): filter is LogicalFilter => 'field' in filter)
      .map((filter) => [filter.field, filter.value]),
  );
};
